import config from '@/config';
import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export const useRevokeAccessToken = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading, error } = useMutation(values => api.base.delete(`${config.appUrls.identity}/api/profile/pats/revoke`, {
        data: values.key,
        headers: {
            'Content-Type': 'application/json',
        },
    }), {
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return {
        revokeAccessToken: mutateAsync,
        isLoading,
        error,
    };
};
